import { Component, Injector } from '@angular/core';
import { ProductsListFiltersComponent } from '../products-list-filters.component';

@Component({
  selector: 'app-product-list-fitlers-desktop',
  templateUrl: './product-list-fitlers-desktop.component.html',
  styleUrl: './product-list-fitlers-desktop.component.css'
})
export class ProductListFitlersDesktopComponent extends ProductsListFiltersComponent {

  constructor(
    private inj: Injector,
  ) {
    super(inj);
  }

}
